import React from 'react';

const WarningSvg = (
  props: React.SVGAttributes<SVGElement>,
): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.7531 10.0264C10.7313 9.91699 10.7641 9.81855 10.8516 9.73105C10.9391 9.64356 11.0375 9.5998 11.1469 9.5998H12.9188C13.0063 9.5998 13.0719 9.62168 13.1156 9.66543C13.1813 9.6873 13.225 9.73105 13.2469 9.79668C13.2906 9.86231 13.3125 9.93887 13.3125 10.0264L13.1156 13.7014C13.0938 13.942 12.9625 14.0623 12.7219 14.0623H11.3438C11.1031 14.0623 10.9719 13.942 10.95 13.7014L10.7531 10.0264ZM12.9844 14.9482C13.2688 15.2107 13.4109 15.5279 13.4109 15.8998C13.4109 16.2717 13.2688 16.5998 12.9844 16.8842C12.7219 17.1467 12.4047 17.2779 12.0328 17.2779C11.6609 17.2779 11.3328 17.1467 11.0484 16.8842C10.7859 16.5998 10.6547 16.2717 10.6547 15.8998C10.6547 15.5279 10.7859 15.2107 11.0484 14.9482C11.3328 14.6639 11.6609 14.5217 12.0328 14.5217C12.4047 14.5217 12.7219 14.6639 12.9844 14.9482ZM13.4109 4.0873L21.2859 17.7373C21.5703 18.2623 21.5594 18.7873 21.2531 19.3123C20.9688 19.8373 20.5203 20.0998 19.9078 20.0998H4.15781C3.54531 20.0998 3.08594 19.8373 2.77969 19.3123C2.49531 18.7873 2.49531 18.2623 2.77969 17.7373L10.6547 4.0873C10.9609 3.5623 11.4203 3.2998 12.0328 3.2998C12.6453 3.2998 13.1047 3.5623 13.4109 4.0873ZM4.32188 18.2295C4.2125 18.4264 4.26719 18.5248 4.48594 18.5248H19.5797C19.6453 18.5248 19.7 18.492 19.7438 18.4264C19.7875 18.3607 19.7875 18.2951 19.7438 18.2295L12.1969 5.17012C12.1531 5.10449 12.0984 5.07168 12.0328 5.07168C11.9672 5.07168 11.9125 5.10449 11.8688 5.17012L4.32188 18.2295Z"
      fill="#F3565D"
    />
  </svg>
);

export default WarningSvg;
